import React, { useEffect, useState } from 'react'
import { createGlobalStyle } from 'styled-components'

import { withGlobalStyles } from 'plugin-liverig/shared/asset/lib/utils'
import Navigation from './navigation/Navigation'
import store from './redux/store'
import { Provider } from 'react-redux'
import './adnocStyles.scss'
import moment from 'moment'

import { LiveApi } from 'live/lib/api'

const Mock = require('./navigation/Mock')

require('./rigDashboards')
require('./wellParameters')
require('./assetFiltersPanel')

if (window?.location?.href?.includes('rig')) {
    const div = document.createElement('div')
    div.id = 'adnoc-rig-customizations'
    document.body.appendChild(div)

    // const globalStyles = createGlobalStyle`
    //   .live-app.rig [class^="AssetProfile__AssetTabs"],
    //   li:nth-child(1) {
    //     display: none;
    //   }`
    //
    // ReactDOM.render(<AdnocRigCustomizations GlobalStyles={globalStyles} />, div)
}

// eslint-disable-next-line react/prop-types
function AdnocRigCustomizations({ GlobalStyles }): JSX.Element {
    return <GlobalStyles />
}

function NavigationWithProvider(): JSX.Element {
    const url = 'services/plugin-asset-metadata/navigation/tree'
    const [items, setItems] = useState<DashboardNode[]>()
    const [loading, setLoading] = useState<boolean>()

    const addDataIntoCache = (cacheName, url, response) => {
        if ('caches' in window) {
            caches.open(cacheName).then(cache => {
                cache.put(url, response)
            })
        }
    }

    const getDataFromCache = async (cacheName, url) => {
        if ('caches' in window) {
            return await caches.open(cacheName).then(cache => {
                return cache.match(url)
            })
        }
    }

    useEffect(() => {
        const getData = async () => {
            const fetchData = () => {
                setLoading(true)
                fetch(url)
                    .then(response => {
                        addDataIntoCache('adnocNavigation', url, response.clone())
                        localStorage.setItem('navigationJsonTime', moment().toDate().getTime().toString())

                        return response.json()
                    })
                    .then(data => {
                        setItems(data)
                        setLoading(false)
                    })
                    .catch(error => {
                        console.error(error)
                        setLoading(false)
                    })
            }

            const lastFetch = localStorage.getItem('navigationJsonTime')
            if (!lastFetch || moment().diff(moment(Number.parseInt(lastFetch)), 'seconds') >= 300) {
                fetchData()
            } else {
                const response = await getDataFromCache('adnocNavigation', url)
                if (response) {
                    const json = await response.json()
                    setItems(json)
                } else {
                    fetchData()
                }
            }
        }

        getData()
    }, [])

    // return <Provider store={store}><Navigation loading={loading} data={Mock} /></Provider>
    return <Provider store={store}>{items != null && <Navigation data={items} loading={loading} />}</Provider>
}

const GlobalStyles = createGlobalStyle`
  .live-app.wellbore {
    height: 100%;

    .app-footer {
      display: none;
    }
  }
`
const ConfiguredApp = withGlobalStyles(NavigationWithProvider, GlobalStyles)

LiveApi.HomePages.register({
    key: 'adnoc-navigation',
    label: 'Adnoc Navigation',
    existsOnMenu: false,
    Page: ConfiguredApp
})
